import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';
import AuthorizationService from '@/api/AuthorizationService';

export const REDIRECT_LINK_STORAGE = `@twism:redirect-link`;

export class HandleSigninRedirectRestrictedPages implements IRouterMiddleware {
  private service = new AuthorizationService();

  canActivate(to: MiddlewareRoute) {
    return to.meta.requiresAuth && !this.service.userIsValidNotRefresh();
  }

  private getAdditionalQueryParams() {
    return location.search && `${location.search.replace(/\?/, '')}&`;
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    localStorage.setItem(
      REDIRECT_LINK_STORAGE,
      `${to.path}?${this.getAdditionalQueryParams()}`
    );
    return next(`/?${this.getAdditionalQueryParams()}redirect_to=${to.path}`);
  }
}
